"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenounceRoleButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const utils_1 = require("../../../utils");
const dialog_1 = require("./dialog");
const RenounceRoleButton = (props) => {
    const { className, contract, contract: { address, contractSecurity, accessControls }, disabled, variant, } = props;
    const [isRenounceRoleDialogOpen, setIsRenounceRoleDialogOpen] = (0, react_1.useState)(false);
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const handleRenounceRole = () => {
        setIsRenounceRoleDialogOpen(true);
    };
    const handleRenounceRoleCancel = () => {
        setIsRenounceRoleDialogOpen(false);
    };
    const handleRenounceRoleConfirm = () => {
        setIsRenounceRoleDialogOpen(false);
    };
    if (contractSecurity !== types_1.ContractSecurity.ACCESS_CONTROL) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleRenounceRole, icon: icons_material_1.NoAccounts, message: "form.buttons.renounceRole", className: className, dataTestId: "RenounceRoleButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.AccessControlRenounceRoleDialog, { onCancel: handleRenounceRoleCancel, onConfirm: handleRenounceRoleConfirm, open: isRenounceRoleDialogOpen, data: { address } })] }));
};
exports.RenounceRoleButton = RenounceRoleButton;
//# sourceMappingURL=index.js.map